<template>
  <el-row style="margin: 10px">
    <el-col :span="24" style="padding: 0px 10px">
      <el-row class="warp">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="主机号：">
              <el-input
                v-model="searchForm.host"
                placeholder="主机号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="回路号：">
              <el-input
                v-model="searchForm.loop"
                placeholder="回路号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位号：">
              <el-input
                v-model="searchForm.point"
                placeholder="点位号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位设备名称：">
              <el-input
                v-model="searchForm.deviceName"
                placeholder="点位设备名称"
                maxlength="100"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位设备型号：">
              <el-input
                v-model="searchForm.deviceSn"
                placeholder="点位设备型号"
                maxlength="100"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址：">
              <el-input
                v-model="searchForm.address"
                placeholder="地址"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="位置：">
              <el-input
                v-model="searchForm.position"
                placeholder="位置"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="showDevice('')"
                >查询</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="resetForm()"
                >重置</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="bindDevice"
                >绑定设备</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="batchRegist"
                >批量注册</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="24"
          v-loading="loading"
          element-loading-text="拼命加载中"
        >
          <!--列表-->
          <el-table
            :data="deviceList"
            highlight-current-row
            border
            lazy
            ref="bindMultipleTable"
            @selection-change="bindSelectionChange"
            :row-key="rowkey"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="checkSelectable"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60"
              fixed="left"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              label="名称"
              align="center"
              width="260"
            ></el-table-column>
            <el-table-column
              prop="host"
              label="主机号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="loop"
              label="回路号"
              align="center"
              width="180"
            ></el-table-column>

            <el-table-column
              prop="point"
              label="点位号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="deviceSN"
              label="型号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="address"
              label="地址"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="position"
              label="位置"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="260"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  style="margin: 0; padding: 5px"
                  @click="remove(scope.$index, scope.row)"
                  >删除</el-button
                >
                <el-button
                  v-if="scope.row.registStatus == 0"
                  size="mini"
                  type="warning"
                  style="margin: 0; padding: 5px"
                  @click="regist(scope.$index, scope.row)"
                  >注册</el-button
                >
                <!-- <el-button
                  size="mini"
                  type="primary"
                  style="margin: 0; padding: 5px 10px"
                  @click="selfReport(scope.$index, scope.row)"
                  >上报</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="float: right"
            >
            </el-pagination>
          </el-col>
        </el-col>
      </el-row>
    </el-col>

    <el-dialog
      :title="bind.title"
      :visible.sync="bind.visible"
      :close-on-click-modal="false"
      width="80%"
      top="5vh"
      :append-to-body="true"
    >
      <el-row>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true" :model="bind.searchForm">
            <el-form-item label="主机号：">
              <el-input
                v-model="bind.searchForm.host"
                placeholder="主机号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="回路号：">
              <el-input
                v-model="bind.searchForm.loop"
                placeholder="回路号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位号：">
              <el-input
                v-model="bind.searchForm.point"
                placeholder="点位号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位设备名称：">
              <el-input
                v-model="bind.searchForm.deviceName"
                placeholder="点位设备名称"
                maxlength="100"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="点位设备型号：">
              <el-input
                v-model="bind.searchForm.deviceSn"
                placeholder="点位设备型号"
                maxlength="100"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址：">
              <el-input
                v-model="bind.searchForm.address"
                placeholder="地址"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="位置：">
              <el-input
                v-model="bind.searchForm.position"
                placeholder="位置"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="bingSearchBtn()"
                >查询</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="noBindResetForm()"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="bind.tableList"
            highlight-current-row
            border
            lazy
            ref="pointMultipleTable"
            @selection-change="handleSelectionChange"
            :row-key="rowkey"
          >
            <el-table-column
              type="selection"
              width="55"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60"
              fixed="left"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              label="名称"
              align="center"
              width="260"
            ></el-table-column>
            <el-table-column
              prop="host"
              label="主机号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="loop"
              label="回路号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="point"
              label="点位号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="deviceSN"
              label="型号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="address"
              label="地址"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="position"
              label="位置"
              align="center"
              width="280"
            ></el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination
              @size-change="bindhandleSizeChange"
              @current-change="bindhandleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="bind.total"
              style="float: right"
            >
            </el-pagination>
          </el-col>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bind.visible = false">取消</el-button>
        <el-button type="primary" @click.native="bindSure" :loading="loading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="bind.sure.title"
      :visible.sync="bind.sure.visible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-row>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :model="bind.sure.data" label-width="160px">
            <el-form-item label="请选择系统：">
              <el-select
                v-model="bind.sure.data.systemId"
                placeholder="请选择系统"
                @change="systemChange"
                style="width: 320px"
              >
                <el-option
                  v-for="item in bind.dictList"
                  :key="item.dictId"
                  :label="item.typeName"
                  :value="item.dictId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择大类：">
              <el-select
                v-model="bind.sure.data.bigId"
                placeholder="请选择大类"
                @change="bigChange"
                style="width: 320px"
              >
                <el-option
                  v-for="item in bind.bigList"
                  :key="item.dictId"
                  :label="item.typeName"
                  :value="item.dictId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择设备类型：">
              <el-select
                v-model="bind.sure.data.typeId"
                placeholder="请选择设备类型"
                style="width: 320px"
              >
                <el-option
                  v-for="item in bind.typeList"
                  :key="item.dictId"
                  :label="item.typeName"
                  :value="item.dictId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span style="font-size: 16px; color: red"
        >注：选择得设备都属于消防平台下的此设备类型</span
      >
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bind.sure.visible = false">取消</el-button>
        <el-button type="primary" @click.native="bind.submit">提交</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import API from "../../api/third/point";
import DeviceAPI from "../../api/third/device";
export default {
  props: {
    deviceId: { type: String, default: null },
    platformId: { type: String, default: null },
    openflg: { type: Number, default: -1 }
  },
  data() {
    return {
      loading: false,
      deviceList: [],
      bindDeviceSelect: [],
      searchForm: {},
      total: 0,
      page: 1,
      limit: 10,
      bind: {
        title: "绑定新设备",
        visible: false,
        total: 0,
        page: 1,
        limit: 10,
        tableList: [],
        submit: function () {},
        systemId: null,
        bigId: null,
        typeId: null,
        bigList: [],
        typeList: [],
        searchForm: {}, //搜索条件
        sure: {
          visible: false,
          data: {},
          title: "提交"
        }
      }
    };
  },
  methods: {
    resetForm: function () {
      this.searchForm = {};
      this.showDevice();
    },
    noBindResetForm() {
      this.bind.searchForm = {};
      this.bindSearch();
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSizeChange(val) {
      this.limit = val;
      this.showDevice();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.showDevice();
    },
    search() {
      let that = this;
      that.page = 1;
      that.limit = 10;
      this.showDevice();
    },
    showDevice(row) {
      let that = this;
      that.loading = true;
      let params = this.searchForm;
      params.page = that.page;
      params.limit = that.limit;
      params.deviceId = that.deviceId;
      API.getList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(result);
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.deviceList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    bindDevice() {
      let that = this;
      that.bind.systemId = null;
      that.bind.bigId = null;
      that.bind.typeId = null;
      that.bind.tableList = [];
      that.$nextTick(() => {
        that.$refs.pointMultipleTable.clearSelection();
      });

      that.bind.visible = true;
      that.bind.searchForm = {};
      that.bindSearch();
    },
    bingSearchBtn() {
      this.bind.page = 1;
      this.bindSearch();
    },
    bindSearch() {
      let that = this;
      let params = that.bind.searchForm;
      console.log(params);
      params.page = that.bind.page;
      params.limit = that.bind.limit;
      params.deviceId = that.deviceId;
      API.bindList(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code == 200) {
              that.bind.total = result.data.total;
              that.bind.tableList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    bindSure() {
      let that = this;
      that.bind.sure.data = {};
      if (!that.bind.selectDevice.length) {
        that.$message.error({
          showClose: true,
          message: "请选择要绑定的设备",
          duration: 2000
        });
        return;
      }
      console.log(that.platformId);
      DeviceAPI.dictList({ platformId: that.platformId })
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.bind.dictList = result.data;
              that.bind.sure.visible = true;
            }
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

      //提交
      that.bind.submit = function () {
        if (!that.bind.sure.data.typeId) {
          that.$message.error({
            showClose: true,
            message: "请选择设备类型",
            duration: 2000
          });
          return;
        }
        let transferIds = that.bind.selectDevice.map((s) => {
          return s.id;
        });

        let parms = {
          deviceId: that.deviceId,
          transferIds: transferIds,
          typeId: that.bind.sure.data.typeId
        };
        console.log(parms);
        API.insert(parms)
          .then(
            function (result) {
              if (result && result.code == 200) {
                that.bind.visible = false;
                that.bind.sure.visible = false;
                that.showDevice();
              }
            },
            function (err) {
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      };
    },
    handleSelectionChange: function (val) {
      this.bind.selectDevice = val;
    },
    bindSelectionChange: function (val) {
      this.bindDeviceSelect = val;
    },
    rowkey: function (row) {
      return row.id;
    },
    bindhandleSizeChange(val) {
      this.bind.limit = val;
      this.bindSearch();
    },
    bindhandleCurrentChange(val) {
      this.bind.page = val;
      this.bindSearch();
    },
    checkSelectable(row) {
      return row.registStatus ? false : true;
    },
    systemChange(val) {
      console.log(val);
      let system = this.bind.dictList.find((s) => s.dictId == val);
      if (system && system.child) {
        this.bind.bigList = system.child;
      }
    },
    bigChange(val) {
      console.log(val);
      let big = this.bind.bigList.find((s) => s.dictId == val);
      if (big && big.child) {
        this.bind.typeList = big.child;
      }
    },
    remove(index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete(row.thirdDeviceTransferId)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code === 200) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.showDevice();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.msg,
                    duration: 1500
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    regist(index, row) {
      let that = this;
      API.regist(row.thirdDeviceTransferId)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200) {
              that.$message.success({
                showClose: true,
                message: "注册成功",
                duration: 1500
              });
              row.registStatus = 1;
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg,
                duration: 1500
              });
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    batchRegist() {
      console.log(this.bindDeviceSelect);
      let that = this;
      let params = [];
      if (that.bindDeviceSelect) {
        that.bindDeviceSelect.forEach((s) => {
          params.push(s.thirdDeviceTransferId);
        });
      }
      API.batchRegist(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200) {
              that.$message.success({
                showClose: true,
                message: "注册成功",
                duration: 1500
              });
              that.$nextTick(() => {
                that.$refs.bindMultipleTable.clearSelection();
              });
              that.showDevice();
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg,
                duration: 1500
              });
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    pointBtn(index, row) {
      this.point.visible = true;
    },
    //消防平台上报数据
    selfReport(index, row) {}
  },
  mounted() {
    this.search();
  }
};
</script>
<style scoped>
.el-menu-item.is-active {
  background-color: rgb(71, 71, 230);
}
</style>



// WEBPACK FOOTER //
// point.vue?2203cbbc